/**
 * Cuban peso.
 */
export var CUP = {
  code: 'CUP',
  base: 10,
  exponent: 2
};